











import { Vue, Component, Inject } from "vue-property-decorator";
import { ILeadProviderData } from "@/models/providers/lead";
import { EmailTypes } from "@/data/enums/emails";

@Component({
  components: {
    "emails-history-provider": () =>
      import("@/components/app/global/emailHistory/emailsHistoryProvider.vue"),
    "email-history-table": () =>
      import("@/components/app/global/emailHistory/emailHistoryTable.vue")
  }
})
export default class AdminLeadTicketsView extends Vue {
  // Injected

  @Inject({ from: "leadProvider" })
  public readonly $leadProvider!: () => ILeadProviderData;

  // Computed

  public get emailHistoryBindings() {
    return {
      emailType: EmailTypes.LEAD,
      emailTypeId: this.$leadProvider().leadId
    };
  }
}
